import { matchIsValidTel } from "mui-tel-input"
import { AcademicLevel, Campus, Consentement, Email, FirstName, LastName, MobilePhoneRequired } from "services/validation"
import * as Yup from "yup"

const schema = Yup.object().shape({
  ...Consentement,
  lead: Yup.object().shape({
    ...AcademicLevel,
    ...Campus,
    ...Email,
    ...FirstName,
    ...LastName,
    ...MobilePhoneRequired



    // MobilePhone: Yup.string().required('Le téléphone est requis').max(64, 'Le téléphone doit contenir au maximum 64 caractères').test('test-mobile-phone', 'Le numéro que vous avez renseigné semble incorrect',
    //   (val) => {
    //     return val === '' || matchIsValidTel(val)
    //   })
  })
})

export default schema
